
declare var window: any;
declare var currentUserInstInfo: any;
class Inst {
  constructor() {

  }

  saveUserInsts(userInsts: any) {
    const currentUserInst = userInsts[0];
    window.currentUserInstInfo = currentUserInst;
    currentUserInstInfo.name = currentUserInst.instName;
    currentUserInstInfo.gmtCreate = currentUserInst.instCreated;
    currentUserInstInfo.phone = currentUserInst.instPhone;
    currentUserInstInfo.wechatStatus = currentUserInst.weChatStatus;
    currentUserInstInfo.mainAccount = currentUserInst.instAdmin;
    currentUserInstInfo.qrCode = currentUserInstInfo.qrCode && currentUserInstInfo.qrCode.replace('http://', 'https://');
    localStorage.setItem('aid', userInsts[0].adminId);
    localStorage.setItem('instId', userInsts[0].instId);
    localStorage.setItem('parentId', userInsts[0].parentId);
    localStorage.setItem('adminName', userInsts[0].adminName);
    if (window.currentUserInstInfo.permissions) {
      var codes = window.currentUserInstInfo.permissions.split(',');// 用户权限码
      window.userPermissionListCodes = codes;
      window.instPermissions = window.currentUserInstInfo.instPermissions.split(',');
     } 
    
  }

  getCurrentInst() {

  }

  changeCurrentInst(inst: any) {

  }
}

export default new Inst();
